module.exports = __webpack_public_path__ + "img/NYCEDC.65a43191.svg";